import { ASCEND } from "../constant/sort";

export const nullSort = (a, b, sortDirection, sortFunc) => {
  if (!a && !b) return 0;
  else if (!a) return sortDirection === ASCEND ? 1 : -1;
  else if (!b) return sortDirection === ASCEND ? -1 : 1;
  return sortFunc();
};

export const dateSort = (a, b, sortDirection) => {
  return nullSort(a, b, sortDirection, () => {
    return Date.parse(a) < Date.parse(b) ? -1 : 1;
  });
};

export const stringSort = (a, b, sortDirection) => {
  return nullSort(a, b, sortDirection, () => {
    a = typeof a === "string" ? a.trim().toLowerCase() : a.toString();
    b = typeof b === "string" ? b.trim().toLowerCase() : b.toString();

    return a.localeCompare(b);
  });
};

export const sortAssignees = (a, b, assigneesIds) => {
  const aIsSelected = assigneesIds.indexOf(a.value) > -1;
  const bIsSelected = assigneesIds.indexOf(b.value) > -1;
  if (aIsSelected === bIsSelected) {
    return a.children.localeCompare(b.children);
  }
  if (aIsSelected && !bIsSelected) {
    return -1;
  }
  if (!aIsSelected && bIsSelected) {
    return 1;
  }
};

export const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const filterSort = (A, B, orderBy = "localSortKey") => {
  return A[orderBy].localeCompare(B[orderBy], "en", { sensitivity: "case", numeric: true });
};

export const defaultSort = { columnKey: null, order: null };
